module.exports = {
      id: "pinterest-usage",
      viewBox: "0 0 24.2 30",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#pinterest-usage",
      toString: function () {
        return this.url;
      }
    }